var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.sti0{fill:#FFFFFF;}\n\t.sti1{fill:none;stroke:#00FFFF;stroke-width:0.6828;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.sti2{fill:#4A22D4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "sti2",
    d: "M4,39.9h87.6c1.8,8,9,14.1,17.6,14.1c8.6,0,15.8-6,17.6-14.1H139c2.2,0,4-1.8,4-4s-1.8-4-4-4h-12.1 c-1.8-8-9-14.1-17.6-14.1c-8.6,0-15.8,6-17.6,14.1H4c-2.2,0-4,1.8-4,4S1.8,39.9,4,39.9z M109.3,25.8c5.6,0,10.1,4.5,10.1,10.1 c0,5.6-4.5,10.1-10.1,10.1c-5.6,0-10.1-4.5-10.1-10.1C99.2,30.4,103.7,25.8,109.3,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sti2",
    d: "M139,65.4H46.8c-1.8-8-9-14.1-17.6-14.1s-15.8,6-17.6,14.1H4c-2.2,0-4,1.8-4,4s1.8,4,4,4h7.6 c1.8,8,9,14.1,17.6,14.1s15.8-6,17.6-14.1H139c2.2,0,4-1.8,4-4S141.2,65.4,139,65.4z M29.2,79.5c-5.6,0-10.1-4.5-10.1-10.1 c0-5.6,4.5-10.1,10.1-10.1s10.1,4.5,10.1,10.1C39.3,75,34.8,79.5,29.2,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sti2",
    d: "M139,103.1h-34.1c-1.8-8-9-14.1-17.6-14.1s-15.8,6-17.6,14.1H4c-2.2,0-4,1.8-4,4s1.8,4,4,4h65.7 c1.8,8,9,14.1,17.6,14.1s15.8-6,17.6-14.1H139c2.2,0,4-1.8,4-4S141.2,103.1,139,103.1z M87.3,117.2c-5.6,0-10.1-4.5-10.1-10.1 c0-5.6,4.5-10.1,10.1-10.1s10.1,4.5,10.1,10.1C97.4,112.6,92.8,117.2,87.3,117.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.bf35ea5a.svg";
export { ForwardRef as ReactComponent };